import { ArrowLeft } from "lucide-react";
import { useSmartNavigation } from "../../hooks/useSmartNavigation";
import Button from "./Button";

interface BackButtonProps {
  fallbackPath: string;
  label?: string;
  variant?: "contained" | "outlined" | "text";
  className?: string;
}

/**
 * Bouton de retour intelligent qui gère la navigation de manière contextuelle
 */
const BackButton = ({
  fallbackPath,
  label = "Retour",
  variant = "outlined",
  className,
}: BackButtonProps) => {
  const { goBack } = useSmartNavigation();

  return (
    <Button
      variant={variant}
      startIcon={<ArrowLeft className="w-4 h-4" />}
      onClick={() => goBack(fallbackPath)}
      className={className}
    >
      {label}
    </Button>
  );
};

export default BackButton;

